export default __webpack_public_path__ + "static/media/icloud.873880f8.svg";